<template>
  <SelectPopover
    :options="filterOptions"
    :modelValue="filterName"
    @update:modelValue="addFilter"
    label="filter-add"
    :key="modelValue.filters.length ? 'hasNoRule' : 'hasRule'"
  >
    <template #button-content>
      <AddIcon16 />
      <slot name="cta">{{ $t('filter.add') }}</slot>
    </template>
  </SelectPopover>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import AddIcon16 from '@components/Icons/AddIcon16.vue';
import type { ListOptions } from '@components/common/SelectionList.vue';
import type { FilterOptions } from '@/filter/types';

export default defineComponent({
  name: 'FilterAdd',

  components: {
    AddIcon16,
  },

  props: {
    filters: {
      type: Object as PropType<FilterOptions>,
      required: true,
    },

    modelValue: {
      type: Object,
      required: true,
    },
  },
  emits: { add: null },

  data(): {
    filterName: string;
  } {
    return {
      filterName: '',
    };
  },

  computed: {
    filterOptions(): ListOptions {
      return Object.entries(this.filters).map(([name]) => ({
        label: this.$t(`filter.filters.${name}.label`),
        value: name,
      }));
    },
  },

  methods: {
    addFilter(name: string) {
      this.filterName = name;

      this.$emit('add', this.filters[name], name);
    },
  },
});
</script>
